module.exports = __webpack_public_path__ + "static/media/common-market-law.50a824cb.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/common-market-law.png
// module id = 1394
// module chunks = 1